export default function LoadingSpinner({ size = 'md' }) {
  const s = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-10 w-10' : 'h-7 w-7';
  return (
    <div className="flex flex-col justify-center items-center py-16 gap-3">
      <div className={`${s} border-2 border-primary-500 border-t-transparent rounded-full animate-spin`} />
      <p className="text-xs text-slate-400 font-medium">Loading…</p>
    </div>
  );
}
